import {
  Box,
  Checkbox,
  FormControlLabel,
  Typography,
} from "@mui/material";
import DynamicInput from "../../../screens/user-kyc/feilds/dynamic-input";
import { RootState } from "../../../store";
import { useState } from "react";
import { useSelector } from "react-redux";
import { sendAadharOtp } from "services/otpService";
import { toast } from "react-toastify";

const KYCDetailsForm = ({
  formik,
  isOtpVerified,
  setIsOtpDialogOpen,
  setRequestId
}: {
  formik: any;
  isOtpVerified: boolean;
  setIsOtpDialogOpen: (open: boolean) => void;
  setRequestId: (requestId: string) => void;
}) => {
  const [loading, setLoading] = useState(false);
  const adharDetails = useSelector(
    (state: RootState) => state.merchantForm.merchantKYC
  ) as any;

  const handleSendOtp = async () => {
    if (!formik.values.confirmadharNumber) {
      return toast.error(
        "Please enter your Aadhaar number before requesting OTP."
      );
    }

    setLoading(true);
    try {
      const response = await sendAadharOtp(formik.values.confirmadharNumber) as any;
      if (response.message === "Success") {
        setRequestId(response?.result?.requestId);
        setIsOtpDialogOpen(true);
      }
    } catch (error) {
      console.error("Error sending OTP:", error);
      toast.error("Failed to send OTP. Please try again.");
    } finally {
      setLoading(false);
    }
  };

  return (
    <Box border={1} borderColor="rgba(0,0,0,0.2)" borderRadius={2.5} p={3}>
      <DynamicInput
        formik={formik}
        name="adharNumber"
        label="Aadhaar Number*"
        type="password"
        value={adharDetails?.maskedAadhaarNumber}
        placeholder="Enter your Aadhaar number"
        inputProps={{
          maxLength: 12,
          inputMode: "numeric",
          pattern: "[0-9]*",
        }}
        disabled={isOtpVerified}
        disableCopyPaste
      />

      <Box display="flex" flexDirection="column" rowGap={1}>
        <DynamicInput
          formik={formik}
          name="confirmadharNumber"
          label="Confirm Aadhaar Number*"
          type="text"
          value={adharDetails?.maskedAadhaarNumber}
          placeholder="Confirm your Aadhaar number"
          inputProps={{
            maxLength: 12,
            inputMode: "numeric",
            pattern: "[0-9]*",
          }}
          verified={isOtpVerified}
          adornment={
            !isOtpVerified
              ? {
                  text: loading ? "Sending..." : "Send OTP to verify",
                  onClick: handleSendOtp,
                }
              : undefined
          }
          disabled={isOtpVerified}
          disableCopyPaste
        />

        <FormControlLabel
          control={
            <Checkbox
              checked={true}
              name="allowFetchDetails"
              color="primary"
              onChange={formik.handleChange}
            />
          }
          label="Allow to fetch your details from authorized sources using your Aadhaar number"
          checked={true}
        />
      </Box>

      {isOtpVerified && (
        <>
          <DynamicInput
            formik={formik}
            name="fullName"
            label="Full Name"
            value={adharDetails?.name}
            type="text"
            placeholder="Enter your full name"
            disabled={true}
          />
          <DynamicInput
            formik={formik}
            name="dateofbirth"
            label="Date of Birth"
            value={adharDetails?.dob}
            type="text"
            placeholder="Enter your Date of Birth"
            disabled={true}
          />
          <DynamicInput
            formik={formik}
            name="address"
            label="Address"
            value={adharDetails?.address}
            type="text"
            placeholder="Enter your address"
            disabled={true}
          />
          <DynamicInput
            formik={formik}
            name="pincode"
            label="Pin Code"
            value={adharDetails?.pincode}
            type="text"
            placeholder="Enter your Pin Code"
            disabled={true}
          />
          <DynamicInput
            formik={formik}
            name="district"
            label="District"
            value={adharDetails?.splitAddress?.dist}
            type="text"
            placeholder="Enter your district"
            disabled={true}
          />
          <DynamicInput
            formik={formik}
            name="state"
            label="State"
            value={adharDetails?.splitAddress?.state}
            type="text"
            placeholder="Enter your state"
            disabled={true}
          />
          <DynamicInput
            formik={formik}
            name="city"
            label="City"
            value={adharDetails?.splitAddress?.vtc}
            type="text"
            placeholder="Enter your city"
            disabled={true}
          />
          <DynamicInput
            formik={formik}
            name="panNumber"
            label="PAN Number"
            value={formik.values.panNumber.toUpperCase()}
            type="text"
            placeholder="Enter your PAN Number"
          />
          <Typography variant="body2" color="textSecondary" mt={2}>
            Press Submit to submit your KYC details.
          </Typography>
        </>
      )}
    </Box>
  );
};

export default KYCDetailsForm;
